export default __webpack_public_path__ + "static/media/heavy_logo.a08ed756.svg";